var map = {
	"./agua-cloaca/agua-cloaca.module": [
		"./src/app/agua-cloaca/agua-cloaca.module.ts",
		"default~agua-cloaca-agua-cloaca-module~auditoria-auditoria-module~seguridad-camaras-seguridad-camara~a9099d3a",
		"default~agua-cloaca-agua-cloaca-module~planta-potabilizadora-planta-potabilizadora-module",
		"default~agua-cloaca-agua-cloaca-module~principal-principal-module",
		"default~agua-cloaca-agua-cloaca-module~config-modulo-mqtt-config-modulo-mqtt-module",
		"common",
		"agua-cloaca-agua-cloaca-module"
	],
	"./auditoria/auditoria.module": [
		"./src/app/auditoria/auditoria.module.ts",
		"default~agua-cloaca-agua-cloaca-module~auditoria-auditoria-module~seguridad-camaras-seguridad-camara~a9099d3a",
		"common",
		"auditoria-auditoria-module"
	],
	"./clima/clima.module": [
		"./src/app/clima/clima.module.ts",
		"clima-clima-module"
	],
	"./config-modulo-mqtt/config-modulo-mqtt.module": [
		"./src/app/config-modulo-mqtt/config-modulo-mqtt.module.ts",
		"default~agua-cloaca-agua-cloaca-module~config-modulo-mqtt-config-modulo-mqtt-module",
		"common",
		"config-modulo-mqtt-config-modulo-mqtt-module"
	],
	"./control-de-stock/control-stock.module": [
		"./src/app/control-de-stock/control-stock.module.ts",
		"common",
		"control-de-stock-control-stock-module"
	],
	"./energia/energia.module": [
		"./src/app/energia/energia.module.ts",
		"energia-energia-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login-login-module"
	],
	"./mantenimiento/mantenimiento.module": [
		"./src/app/mantenimiento/mantenimiento.module.ts",
		"mantenimiento-mantenimiento-module"
	],
	"./planta-potabilizadora/planta-potabilizadora.module": [
		"./src/app/agua-cloaca/planta-potabilizadora/planta-potabilizadora.module.ts",
		"default~agua-cloaca-agua-cloaca-module~planta-potabilizadora-planta-potabilizadora-module",
		"common"
	],
	"./principal/principal.module": [
		"./src/app/principal/principal.module.ts",
		"default~agua-cloaca-agua-cloaca-module~principal-principal-module",
		"default~principal-principal-module~seguridad-camaras-seguridad-camaras-module",
		"common",
		"principal-principal-module"
	],
	"./seguridad-camaras/seguridad-camaras.module": [
		"./src/app/seguridad-camaras/seguridad-camaras.module.ts",
		"default~agua-cloaca-agua-cloaca-module~auditoria-auditoria-module~seguridad-camaras-seguridad-camara~a9099d3a",
		"default~principal-principal-module~seguridad-camaras-seguridad-camaras-module",
		"common",
		"seguridad-camaras-seguridad-camaras-module"
	],
	"./sube/sube.module": [
		"./src/app/sube/sube.module.ts",
		"default~agua-cloaca-agua-cloaca-module~auditoria-auditoria-module~seguridad-camaras-seguridad-camara~a9099d3a",
		"common",
		"sube-sube-module"
	],
	"./sysdiags/sysdiag.module": [
		"./src/app/sysdiags/sysdiag.module.ts",
		"sysdiags-sysdiag-module"
	],
	"./transito/transito.module": [
		"./src/app/transito/transito.module.ts",
		"default~agua-cloaca-agua-cloaca-module~auditoria-auditoria-module~seguridad-camaras-seguridad-camara~a9099d3a",
		"common",
		"transito-transito-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;